import { FrameFactories, FrameViews } from "@com.mgmtp.a12.client/client-core/lib/core/frame";
import { ApplicationModel } from "@com.mgmtp.a12.client/client-core/lib/core/model";

import { CustomModalRegionUi } from "../page/CustomModalRegionUi";

export const customRegionUiProvider: FrameViews.RegionUiProvider = function customRegionUiProvider(regionRef) {
	return ApplicationModel.Region.Reference.equal(["MODAL"], regionRef)
		? CustomModalRegionUi
		: FrameFactories.regionUiProvider(regionRef);
};
